import dayjs from "dayjs";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import ConfirmDialog from "../../layouts/confirmDialog/confirmDialog.vue";
import SupervisorUnloadingPlaceForMapRestModel from "../../models/rest/supervisor/supervisorUnloadingPlaceForMapRestModel";

@Component({
    props: {
        currentInfoWindow: {},
        totalDistance: {
            default: ""
        },
        totalTime: {
            default: ""
        }
    },
    components: {
        "confirm-dialog": ConfirmDialog
    }
})

export default class SupervisorUnloadingPlaceForMapInfoWindow extends Vue {
    tab = "";
    currentInfoWindow!: any;
    avoidHighways: boolean = false;
    avoidTolls: boolean = false;
    waystations: any[] = [];
    timeout: number | undefined;
    addressSearchArray: string[] = [];

    get addressFound() {
        if (this.$store.direct.state.common.addressFound == null) {
            return [];
        }
        return this.$store.direct.state.common.addressFound;
    }

    get supervisorUnloadingPlaceForMap(): SupervisorUnloadingPlaceForMapRestModel {
        const supervisorUnloadingPlaceForMap = this.$store.direct.state.supervisor.supervisorUnloadingPlaceForMap;
        this.waystations = [];
        this.waystations.push({ lat: supervisorUnloadingPlaceForMap.lat, lng: supervisorUnloadingPlaceForMap.lng, fullPlaceName: supervisorUnloadingPlaceForMap.city }, {});
        return supervisorUnloadingPlaceForMap;
    }

    addressSearchLoadItems(index: number) {
        if (this.addressSearchArray[index] != null && this.addressSearchArray[index].length > 3) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.$store.direct.dispatch.common.searchAddresses({ searchText: this.addressSearchArray[index] });
            }, 1000);
        }
    }

    async unavailableClick() {
        this.$store.direct.dispatch.confirm.openConfirmDialog({
            showConfirmDialog: true,
            title: `${this.$t("map.unavailable")}: "${this.supervisorUnloadingPlaceForMap.supervisorOrderId}"`,
            message: `${this.$t("map.unavailableMessage")}`,
            links: [],
            options: { buttonColor: "primary", layoutColor: "primary" },
            buttonType: 'yes/no'
        })
            .then(async confirm => {
                if (confirm) {
                    await this.$store.direct.dispatch.supervisor.setSupervisorUnloadingPlaceForMapAsUnavailable({ id: this.supervisorUnloadingPlaceForMap.id });
                    this.$emit("unavailableSupervisorUnloadingPlaceForMapClick", this.supervisorUnloadingPlaceForMap.id)
                }
            })
    }

    addDestinationClick() {
        this.waystations.push({});
        this.addressSearchArray.push("");
    }

    getDirectionClick() {
        this.$emit("getDirectionClick", this.waystations, this.avoidHighways, this.avoidTolls)
    }

    removeDestination(index: number) {
        this.waystations.splice(index, 1);
        this.addressSearchArray.splice(index, 1);
    }

    formatDateTime(dateTime: any) {
        if (dateTime != null) {
            return dayjs(dateTime).format("YYYY-MM-DD HH:mm");
        }
    }

    closeInfoWindowClick() {
        this.currentInfoWindow.close();
    }
}